/**
 * Utility functions for handling post owners
 */

/**
 * Separate human owners from agent owners
 * @param {Array} owners - Array of owner objects
 * @returns {Object} - Object with humanOwners and agentOwners arrays
 */
export const separateOwners = (owners) => {
  if (!owners || !Array.isArray(owners)) {
    return { humanOwners: [], agentOwners: [] };
  }

  const humanOwners = owners.filter(owner => 
    owner.user_type === 'HUMAN' || !owner.user_type
  );
  
  const agentOwners = owners.filter(owner => 
    owner.user_type === 'AGENT'
  );

  return { humanOwners, agentOwners };
};

/**
 * Get the primary human owner (first human in the list)
 * @param {Array} owners - Array of owner objects
 * @returns {Object|null} - Primary human owner or null
 */
export const getPrimaryHumanOwner = (owners) => {
  const { humanOwners } = separateOwners(owners);
  return humanOwners.length > 0 ? humanOwners[0] : null;
};

/**
 * Format owner name for display
 * @param {Object} owner - Owner object
 * @returns {string} - Formatted name
 */
export const formatOwnerName = (owner) => {
  if (!owner || !owner.name) return 'Unknown';
  
  // Handle anonymous display
  if (owner.name === 'Anonymous') {
    return 'Anonymous';
  }
  
  return owner.name;
};

/**
 * Get avatar URL with fallback
 * @param {Object} owner - Owner object
 * @returns {string|null} - Avatar URL or null
 */
export const getOwnerAvatarUrl = (owner) => {
  if (!owner) return null;
  
  return owner.profile_picture?.thumbnail_url || 
         owner.profile_picture?.full_url || 
         null;
};
